import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';
import SalesDashboard from '../components/SalesDashboard/SalesDashboard';
import { Alert } from 'antd';

const SalesDashboardView: React.FC = () => {
    const { currentUser } = useAuth();

    // Check if user has Master role access
    const isMasterUser = currentUser?.role?.code === 'master';

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    if (!isMasterUser) {
        return (
            <div style={{ padding: '24px' }}>
                <Alert
                    message="Access Denied"
                    description="You need Master role permissions to access the Sales Dashboard."
                    type="error"
                    showIcon
                />
            </div>
        );
    }

    return <SalesDashboard />;
};

export default SalesDashboardView;
